import React from "react";
import DefaultEntityConsult from "components/form/DefaultEntityConsult";
import Variedade from "entity/Variedade";

export default function VariedadeConsulta() {
    return (
        <DefaultEntityConsult
            EntityClass={Variedade}
            initialFilters={{ status: "ATIVO" }}
            titulo="Variedades"
            routeForm="_variedade"
            showEdit={true}
            showDelete={true}
        />
    );
}
